module.exports = __webpack_public_path__ + "assets/img/Claim_btn.a8bab58c.png";